import {
  MeditationPage,
  MeditationPageQuery,
  MeditationPageQueryVariables,
  MeditationEntity,
  MeditationQuery,
  MeditationDetailPageQuery,
  MeditationDetailPageQueryVariables,
  MeditationDetailPage,
  MeditationsQuery,
  MeditationsQueryVariables,
} from '@/graphql/generated/graphql';
import requestHandler from '../requestHandler';
import { initializeApollo } from '../lib/apollo-client';

import {
  QUERY_MEDITATION,
  QUERY_MEDITATION_DETAIL_PAGE,
  QUERY_MEDITATION_PAGE,
  QUERY_MEDITATIONS,
} from '@/graphql/queries/meditation/meditation';

export const fetchMeditationPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<MeditationPageQuery, MeditationPageQueryVariables>({
      query: QUERY_MEDITATION_PAGE,
    }),
  );

  if (error) {
    console.error('Error fetching meditation page', error);
    return { page: null };
  }

  return {
    page: data?.meditationPage?.data?.attributes as MeditationPage,
  };
};

export const fetchMeditationPageable = async (page: number = 1) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<MeditationsQuery, MeditationsQueryVariables>({
      query: QUERY_MEDITATIONS,
      variables: {
        page,
      },
    }),
  );

  if (error) {
    console.error('Error fetching meditation', error);
    return { meditations: null };
  }

  return {
    meditations: data?.meditations?.data,
    meta: data?.meditations?.meta,
  };
};

export const fetchMeditation = async (slug: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<MeditationQuery>({
      query: QUERY_MEDITATION,
      fetchPolicy: 'cache-first',
      variables: {
        slug: [slug],
      },
    }),
  );

  if (error) {
    console.error('Error fetching podcast', error);
    return { meditation: null };
  }

  if (!data?.meditations?.data.length) {
    return { meditation: null };
  }

  return {
    meditation: data?.meditations?.data[0] as MeditationEntity | null,
  };
};

export const fetchMeditationDetailPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<MeditationDetailPageQuery, MeditationDetailPageQueryVariables>({
      query: QUERY_MEDITATION_DETAIL_PAGE,
    }),
  );

  if (error) {
    console.error('Error fetching meditation detail page', error);
    return { page: null };
  }

  return {
    page: data?.meditationDetailPage?.data?.attributes as MeditationDetailPage,
  };
};
